import React from "react";
import { H2 } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { CreditTransactions } from "../elements/CreditTransactions";

export const History = () => {
  const { t } = useTranslation("translation", { keyPrefix: "History Page" });
  return (
    <div>
      <div style={{ marginBottom: "24px" }}>
        <H2>{t("Credit Transaction Headline")}</H2>
      </div>
      <CreditTransactions />
    </div>
  );
};
